import { trans } from 'trans-js';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { buildSiteTranslationKey, normalizeTranslationKey, resolveTranslationLocale } from './translationUtils';

const translateSiteKey = (key, replace, pluralize, Lingua, locale) => {
    const normalizedKey = normalizeTranslationKey(key);

    if (normalizedKey === '') {
        return '';
    }

    try {
        return trans(buildSiteTranslationKey(normalizedKey), replace, pluralize, {
            Lingua,
            locale: resolveTranslationLocale(locale, Lingua),
        });
    } catch (error) {
        return normalizedKey;
    }
};

export default {
    install: (app, options) => {
        const page = usePage();
        const locale = computed(() => page.props?.locale);

        const translationCallback = (key, replace) => {
            return translateSiteKey(key, replace, false, options.Lingua, locale.value);
        };

        app.config.globalProperties.__t = translationCallback;

        app.mixin({
            methods: {
                __t: translationCallback,
            },
        });

        app.provide('__t', translationCallback);
    },
};
